import { Grid2x2 } from "lucide-react";
import { useSearchParams } from "react-router";

import { SKUCommand } from "@/components/sku-command";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const SkuDropdownMenu = () => {
  const [searchParams] = useSearchParams();

  const templateId = searchParams.get("templateId");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          <Grid2x2 /> SKU ID {templateId && <Badge>{templateId}</Badge>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <SKUCommand />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
